import React, { Children, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";


// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: "theme.palette.text.secondary",
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const MuiDropDown = ({ header, HeaderIcon, menuList, activeLink }) => {
  let windowWidth = window.screen.width;
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    
    setAnchorEl(null);

    
  };

  return (
    <>
      <MuiTheme>
        <div>
          <Button
            sx={{ color: "white", backgroundColor: "transparent" }}
            id="demo-customized-button"
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
          >
            <div className="flex items-center">
              <HeaderIcon />
              <span className="sidebar-header">{header}</span>
            </div>
          </Button>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
              onMouseLeave: handleClose,
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {menuList.map((item, index) => {
              return (
                <MenuItem onClick={() => navigate(item.route)}>
                  <span
                    className={
                      item.isActive == activeLink
                        ? "sidebar-active-link"
                        : "sidebar-link"
                    }
                  >
                    {item.name}
                  </span>
                </MenuItem>
              );
            })}
          </StyledMenu>
        </div>
      </MuiTheme>
    </>
  );
};

export default MuiDropDown;
